import { useTranslation } from 'react-i18next'

import { CaretRightIcon } from '@phosphor-icons/react'

import * as Styles from './styles'

const Title = ({ isParent, tab, onClick }) => {
  const { t } = useTranslation()

  const handleClick = () => {
    if (onClick) {
      onClick(tab)
    }
  }

  return (
    <Styles.TitleContainer isParent={isParent} onClick={handleClick}>
      {tab?.Icon && <tab.Icon size={24} weight="light" />}
      {t(tab.label)}
      {isParent && <CaretRightIcon data-testid="arrowRight" />}
    </Styles.TitleContainer>
  )
}

export default Title
